module.exports = __webpack_public_path__ + "static/media/consultant.90994423.svg";